import LetsEncrypt from "../../../../src/courses/partials/ssl/lets-encrypt.mdx";
import * as React from 'react';
export default {
  LetsEncrypt,
  React
};